import api from './api';

export interface LightspeedLocation {
  businessLocationId: number;
  businessLocationName?: string;
  businessId: number;
  businessName?: string;
  currencyCode?: string;
  timezone?: string;
  country?: string;
  /** Already has a source in this business — offered read-only, not hidden, so
   *  the picker can say why it cannot be chosen again. */
  alreadyConnected: boolean;
}

export const lightspeedApi = {
  initiateConnection: async (organizationId: string): Promise<{ authorizationUrl: string }> => {
    if (!organizationId) {
      throw new Error('Organization ID is required but not provided.');
    }
    const response = await api.post('/api/integrations/lightspeed/connect', { organizationId });
    return response.data;
  },

  /** The locations a parked authorization offers. Does not consume it. */
  getPendingLocations: async (
    pendingId: string,
    organizationId: string,
  ): Promise<{ locations: LightspeedLocation[] }> => {
    const response = await api.get(`/api/integrations/lightspeed/pending/${pendingId}`, {
      params: { organizationId },
    });
    return response.data;
  },

  complete: async (
    pendingId: string,
    businessLocationIds: number[],
    organizationId: string,
  ): Promise<{ success: boolean; dataSourceIds: string[] }> => {
    const response = await api.post('/api/integrations/lightspeed/complete', {
      pendingId,
      businessLocationIds,
      organizationId,
    });
    return response.data;
  },
};
